import { clamp } from "@/lib/utils/marketSimilarity/tableUtils";

/**
 * Compute ECharts dataZoom start/end percentages from a target date
 * within the xAxisData array.
 * 
 * @param xAxisData - Array of date strings (sorted)
 * @param targetDate - The date string to center on
 * @param windowSize - Number of data points on either side (e.g., 20)
 * @returns Zoom range as percentages, or null if targetDate not found
 */
export function computeZoomRange(
  xAxisData: string[],
  targetDate: string,
  windowSize: number
): { startPercent: number; endPercent: number } | null {
  if (xAxisData.length === 0) {
    return null;
  }

  const index = xAxisData.indexOf(targetDate);
  if (index === -1) {
    return null;
  }

  const length = xAxisData.length;
  const startIdx = clamp(index - windowSize, 0, length - 1);
  const endIdx = clamp(index + windowSize, 0, length - 1);

  // Avoid division by zero for single-element arrays
  const divisor = length > 1 ? length - 1 : 1;
  const startPercent = (startIdx / divisor) * 100;
  const endPercent = (endIdx / divisor) * 100;

  return { startPercent, endPercent };
}
